/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/IClearBoardsAuthority',[], function () {
    "use strict";

    var IClearBoardsAuthority = function () {
        this.BoardsToClear = 0;
    };

    return IClearBoardsAuthority;

});
